import React, { useState, useEffect, useContext } from 'react';
import featureToggle from '../../../featureToggle.json';
import Dev from '../../dev/Dev';
import { Flex } from '@aws-amplify/ui-react';
import { useIdleTimer } from '../../../utils/IdleTimer';
import { FiltersContext } from '../../../components/Navigation/Routes';
import { Button, IconButton, Modal } from '@mui/material';
import { Box } from '@mui/system';
import ClearIcon from '@mui/icons-material/Clear';
import { SigmaEmbed } from '../../../layouts/SigmaEmbed';
import usersService from '../../../axios/usersService';
import styles from '../reportPageHeader.module.css';

export const Forecasts = ({ page }) => {
  const context = useContext(FiltersContext);
  const { channel, impersonatorInfo, viewType } = context;

  const environment = process.env.REACT_APP_ENVIRONMENT;

  const [openFAQ, setOpenFAQ] = useState(false);
  const handleOpenFAQ = () => setOpenFAQ(true);
  const handleCloseFAQ = () => setOpenFAQ(false);
  const [faqSource, setFAQSource] = useState(null);

  useEffect(() => {
    const fetchFAQEmbed = async () => {
      const roleInformation =
        Object.values(impersonatorInfo).length === 0 ? {} : impersonatorInfo;
      roleInformation.view = viewType;
      const srcFAQ = await usersService.getEmbeddingUrl(
        'forecasts-faq',
        [],
        roleInformation,
        Object.values(impersonatorInfo).length > 0,
      );
      setFAQSource(srcFAQ);
    };

    if (page === 'sif') {
      fetchFAQEmbed();
    }
  }, [openFAQ, impersonatorInfo, viewType, page]);

  useIdleTimer(channel);

  if (featureToggle[environment][page]) {
    return (
      <Flex
        direction={'column'}
        width={'100%'}
        height={'100%'}
        overflow={'hidden'}
        paddingTop={'12px'}
      >
        <Flex direction={'row'} className={styles['actions-row']}>
          <Button className="information-buttons">Detailed Reports</Button>
          <Flex direction={'row'} justifyContent={'flex-end'} width={'80%'}>
            <Button onClick={handleOpenFAQ} id="vendor-metrics-button">
              Vendor Metrics FAQ
            </Button>
            <Modal
              className="embed-popup"
              open={openFAQ}
              onClose={handleCloseFAQ}
            >
              <Box className="embed-popup-box">
                <div className="popup-close">
                  <IconButton onClick={handleCloseFAQ}>
                    <ClearIcon color={'error'} />
                  </IconButton>
                </div>
                <iframe
                  id={'FAQ'}
                  src={faqSource}
                  title={'FAQ'}
                  className="popup-iframe"
                />
              </Box>
            </Modal>
          </Flex>
        </Flex>

        <SigmaEmbed page={'sif'} />
      </Flex>
    );
  } else {
    return <Dev />;
  }
};
